export class PagedResult<T> {
  public TotalCount: number = 0;
  public TotalPages: number = 0;
  public CurrentPageNumber: number = 0;
  public PageSize: number = 0;
  public Result: T;

  public constructor(initResult?: T) {
    if (arguments.length > 0) this.Result = initResult;
  }
}
